export default function objectToQueryString(
    object: Record<string, string | undefined>
) {
    return Object.entries(object)
        .map(([key, value]) => `${key}=${encodeURIComponent(value ?? '')}`)
        .join('&');
}
